import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';

import themeStyles from './styles/AccessoryCreditOffers.styles';

const ContentWrapper = themeStyles.apply(Box, 'ContentWrapper');
const OfferWrapper = themeStyles.apply(Box, 'OfferWrapper');

const OfferContent = ({ content, dataTestId }) =>
  content ? (
    <Copy mt="-5px" size={['small', 'regular']} fontWeight="bold" color="red" data-testid={dataTestId}>
      {content}
    </Copy>
  ) : null;

const AccessoryCreditOffers = ({ accessoryCreditOffers, showAccessoryCreditOffer, children }) => {
  const isThereContentToShow =
    showAccessoryCreditOffer &&
    !!(accessoryCreditOffers?.firstOffer || accessoryCreditOffers?.secondOffer || accessoryCreditOffers?.thirdOffer);
  return isThereContentToShow ? (
    <>
      <ContentWrapper>
        <OfferWrapper data-testid="cy-accesory-credit-contents">
          <OfferContent dataTestId="cy-credit-first-offer" content={accessoryCreditOffers.firstOffer} />
          <OfferContent dataTestId="cy-credit-second-offer" content={accessoryCreditOffers.secondOffer} />
          <OfferContent dataTestId="cy-credit-third-offer" content={accessoryCreditOffers.thirdOffer} />
        </OfferWrapper>
      </ContentWrapper>
      {children}
    </>
  ) : null;
};

export default AccessoryCreditOffers;
